import { ON_COUNT_DOWN } from '../state-constants/stateConstants';

export const onCountDown = (num) => ({
  type: ON_COUNT_DOWN,
  payload: num,
});



// WEBPACK FOOTER //
// ./src/state-actions/onCountDown.js